import { render, staticRenderFns } from "./BookingItemView.vue?vue&type=template&id=d4229886&scoped=true&"
import script from "./BookingItemView.vue?vue&type=script&lang=js&"
export * from "./BookingItemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4229886",
  null
  
)

export default component.exports